import { BarceloComponent } from "components-utils";

const HotelComponents = {
  cardHotel: BarceloComponent({
    selector: ".c-card-hotel, .c-card-hotel-list, .c-label--tag-all-included, .myb-favorite-hotels",
    path: "barcelo/hotel/card-hotel/js/card-hotel",
    enableObserver: true,
  }),

  meetingTable: BarceloComponent({
    selector: ".c-meeting__table, .c-meeting__modal, .meeting__table",
    path: "barcelo/hotel/meeting-table/js/meeting-table",
  }),

  hotelHorizontalCompact: BarceloComponent({
    selector: ".mod--horizontal-card-compact",
    path: "barcelo/hotel/hotel-horizontal-compact/js/hotel-horizontal-compact",
  }),

  dorintHotelCards: BarceloComponent({
    selector: ".c-dorint-hotel-cards-JS",
    path: "barcelo/hotel/dorint-hotel-cards/js/dorint-hotel-cards",
  }),

  hotelRelated: BarceloComponent({
    selector: ".c-hotel-related-JS",
    path: "barcelo/hotel/hotel-related/js/hotel-related",
  }),

  weather: BarceloComponent({
    selector: ".c-weather",
    path: "barcelo/hotel/hotel-weather/js/c-hotel-weather",
  }),

  hotelHighlights: BarceloComponent({
    selector: ".js-c-hotel-highlights",
    path: "barcelo/hotel/hotel-highlights/js/hotel-highlights",
  }),

  hotelListCarousel: BarceloComponent({
    selector: ".c-hotel-list-carousel",
    path: "barcelo/hotel/hotel-list-carousel/js/hotel-list-carousel",
    enableObserver: true,
    ignoreViewport: true,
  }),

  tripAdvisor: BarceloComponent({
    selector: ".c-tripadvisor, .c-tripadvisor__rate",
    path: "barcelo/hotel/trip-advisor/js/trip-advisor",
    enableObserver: true,
    ignoreViewport: true,
  }),

  hotelReturn: BarceloComponent({
    selector: ".hotel-return-JS",
    path: "barcelo/hotel/hotel-return/js/hotel-return",
  }),

  hotelMapCard: BarceloComponent({
    selector: ".hotel-map-card, .c-hotel-map-card",
    path: "barcelo/hotel/hotel-map-card/js/c-hotel-map-card",
  }),
};

export default HotelComponents;
